"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = require("lodash");
var perf = {
    mark: (typeof window === 'object' &&
        window &&
        window.performance &&
        window.performance.mark &&
        window.performance.mark.bind(window.performance)) ||
        lodash_1.noop,
    measure: (typeof window === 'object' &&
        window &&
        window.performance &&
        window.performance.measure &&
        window.performance.measure.bind(window.performance)) ||
        lodash_1.noop,
};
exports.default = perf;
